import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { User } from 'src/app/_models';
import { CommentNode } from 'src/app/_models/document';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DocumentService } from 'src/app/_services/document.services';

interface CommentFlatNode {
  expandable: boolean;
  id: number;
  comment: string;
  comment_by: string;
  document_version: number
  level: number;
}

@Component({
  selector: 'app-comments-section',
  templateUrl: './comments-section.component.html',
  styleUrls: ['./comments-section.component.scss']
})
export class CommentsSectionComponent implements OnInit {

  

  @Input() documentId: string;
  @Input() versionNumber: number;
  @Output() openCommentTab = new EventEmitter<boolean>()

  //userComments: any
  comment: string = null;
  replyComment: string = null;
  currentUser: User
  commentToReply: any;
  isChild: boolean = false

  private _transformer = (node: CommentNode, level: number) => {
    return {
      expandable: !!node.threads && node.threads.length > 0,
      id: node.id,
      comment: node.comment,
      level: level,
      comment_by: node.comment_by,
      document_version: node.document_version
    };
  }

  treeControl = new FlatTreeControl<CommentFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.threads);

  userComments = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private documetService: DocumentService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  
  hasChild = (_: number, node: CommentFlatNode) => node.expandable;
  ngOnInit() {
    this.fetchComments()
  }

  fetchComments() {
    this.documetService.getComments(this.documentId).subscribe(comments => {
      this.userComments.data = comments
    })
  }

  addComment() {
    var payload = {
      document_id: this.documentId,
      comment: this.comment,
      document_version: this.versionNumber,
      comment_by: this.currentUser.username
    }
    //console.log("Comment payload", payload)
    this.documetService.addComment(payload).subscribe(resp => {
      this.comment = ""
      this.fetchComments()
    })
  }

  replyToComment(comment) {
    this.commentToReply = comment
  }

  closeReply() {
    this.commentToReply = null
  }

  reply() {
    var payload = {
      parent_comment_id : this.commentToReply.id,
      comment: this.replyComment,
      comment_by: this.currentUser.username,
      document_version: parseInt(this.commentToReply.document_version),
      document_id: this.documentId

    }
    this.documetService.addComment(payload).subscribe(resp => {
      this.commentToReply = false
      this.replyComment = ""
      this.fetchComments()
    })
  }

  replyCancel(){
    this.commentToReply = false
  }

  back() {
    this.openCommentTab.emit(false)
  }

}
